export default "__VITE_ASSET__T_tGh2qL__"